import { CreateOrganizationUserPayloadType } from '@/api/v1/opco/organizations/createOrganizationUserApi';
import { ORG_ADMIN_ROLE } from '@/const/user';
import {
  REQUIRED_EMAIL_VALIDATOR,
  REQUIRED_PHONE_NUMBER_VALIDATOR,
  REQUIRED_TEXT_FIELD_VALIDATOR,
  STRING_VALIDATOR,
  TEXT_FIELD_VALIDATOR,
} from '@/helpers/formHelpers/validators';
import { object } from 'yup';

export const getCreateOrganizationUserInitialValues = (
  canCreateOrgAdminRole: boolean
): CreateOrganizationUserPayloadType => {
  return {
    role: canCreateOrgAdminRole ? ORG_ADMIN_ROLE.ORG_ADMIN : ORG_ADMIN_ROLE.MASTER_ADMIN,
    email: '',
    mobile_phone: '',
    first_name: '',
    middle_name: '',
    last_name: '',
  };
};

export const CREATE_ORGANIZATION_USER_VALIDATION_SCHEMA = object().shape({
  role: STRING_VALIDATOR,
  email: REQUIRED_EMAIL_VALIDATOR,
  mobile_phone: REQUIRED_PHONE_NUMBER_VALIDATOR,
  first_name: REQUIRED_TEXT_FIELD_VALIDATOR,
  middle_name: TEXT_FIELD_VALIDATOR,
  last_name: REQUIRED_TEXT_FIELD_VALIDATOR,
});
